import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import SoundProps from "../Misc/SoundProps";
import Tools from "../Misc/Tools";
import SoundManager from "./SoundManager";

export default class ReactSoundManager extends SoundManager {

	constructor() {
		super();
		
	}

	render() {
		return (
			<ReactSoundUI soundManager={this}></ReactSoundUI>
		);
	}
}

const ReactSoundUI = (props: ReactSoundConfig) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	useEffect(() => {
		props.soundManager.onForceUpdate = () => {
			setForceUpdate(!forceUpdate);
		};
	})
	return (
		<>
		</>
	)
};

export interface ReactSoundConfig {
	soundManager: ReactSoundManager;
}